var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgVoicePlay = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M8 14.666A6.667 6.667 0 1 1 8 1.333a6.667 6.667 0 0 1 0 13.333Zm0-1.333A5.333 5.333 0 1 0 8 2.666a5.333 5.333 0 0 0 0 10.667Zm-.919-7.724 3.253 2.169a.267.267 0 0 1 0 .444L7.081 10.39a.267.267 0 0 1-.414-.222V5.831a.267.267 0 0 1 .414-.222Z", fill: "#CC9E6C" }));
export { SvgVoicePlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMTQuNjY2QTYuNjY3IDYuNjY3IDAgMSAxIDggMS4zMzNhNi42NjcgNi42NjcgMCAwIDEgMCAxMy4zMzNabTAtMS4zMzNBNS4zMzMgNS4zMzMgMCAxIDAgOCAyLjY2NmE1LjMzMyA1LjMzMyAwIDAgMCAwIDEwLjY2N1ptLS45MTktNy43MjQgMy4yNTMgMi4xNjlhLjI2Ny4yNjcgMCAwIDEgMCAuNDQ0TDcuMDgxIDEwLjM5YS4yNjcuMjY3IDAgMCAxLS40MTQtLjIyMlY1LjgzMWEuMjY3LjI2NyAwIDAgMSAuNDE0LS4yMjJaIiBmaWxsPSIjQ0M5RTZDIi8+PC9zdmc+";
